export const ORGANIZATIONS_KEYS = {
  all: ['organizations'] as const,
  byOrg: (orgId: string) => ['organizations', orgId] as const,
  detail: (orgId: string, id: string) => ['organizations', orgId, 'detail', id] as const,
};
